import { Router, NavigationEnd, ActivatedRoute, NavigationStart,  Params } from "@angular/router";
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Breadcrumb, Param } from './breadcrumbs.models';
import { ShellRestService } from '../shell.rest';
import { MediaMatcher } from "@angular/cdk/layout";
import { ShellSideNavService } from "../shell-sidenav.service";
import { throwToolbarMixedModesError } from "@angular/material";

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent implements OnInit {
  
  public mobileQuery: MediaQueryList;

  private breadcrumbs: Breadcrumb[] = [];
  private path: string;

  oldPath = '';
  oldParams: Array<Array<Param>> = new Array<Array<Param>>();

  public constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private route: ActivatedRoute,
    private shellService: ShellRestService,
    private shellSideNavService: ShellSideNavService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQuery.addListener(() => changeDetectorRef.detectChanges());

    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((e) => {
      if(this.router.url  !== 'login'
        && !this.router.url.startsWith('/changepassword')
        && !this.router.url.startsWith('/resetpassword')
        ){
        this.Update();
      }
    });
  }

  public ngOnInit() {
  }

  private onBreadcrumbClick(breadcrumb: Breadcrumb) {
    if(breadcrumb.path == null)
    {
      return;
    }
    let params = {};
    if(breadcrumb.queryParams.length > 0){

      breadcrumb.queryParams.forEach( p => {
        params[p.key] = p.value;
      });
      if(breadcrumb.pathParam !== ''){
        this.router.navigate([breadcrumb.path, breadcrumb.pathParam], {queryParams: params});
      }else{
        this.router.navigate([breadcrumb.path], {queryParams: params});
      }
    }
    else{

      this.router.navigate([breadcrumb.path]);
    }
  }

  private Update()
  {
    this.path = this.router.url;
    this.checkPaths();
    this.shellService.PostBreadcrumbs(this.path, this.oldParams).subscribe(b => {
      this.breadcrumbs = b;
    });
  }

  checkPaths() {
    let olPathWithoutParams = this.oldPath.substring(0,this.oldPath.indexOf('?'));
    let params: Array<Param>;
    if(this.oldPath === ''){
      this.oldPath = this.path; 
      params = this.getListOfParams();
      this.oldParams = new Array<Array<Param>>();
    } else {
      if(olPathWithoutParams === ''){
        olPathWithoutParams = this.oldPath;
      }
      if(this.path.length > this.oldPath.length && this.path.startsWith(olPathWithoutParams)) {
        this.oldPath = this.path;
        params = this.getListOfParams();
      } else {
        this.oldPath = this.path;
        this.oldParams = new Array<Array<Param>>();
        params = this.getListOfParams();
      }
    }

    if(params.length >0){
      this.oldParams.push( params);
    }
  }


  getListOfParams(){
    let params: Array<Param>;
    this.route.queryParamMap.forEach(e => 
    {
      params = new Array<Param>();
      e.keys.forEach(k => {
        var param = new Param();
        param.key = k;
        param.value =  this.route.snapshot.queryParamMap.get(k);
        params.push(param);
      });
    })
    return params;
  }

  addShortcut() {
    let currentPath = this.router.url;
    console.log(`Shortcut: ${this.breadcrumbs.map(b => {
    console.log("BreadcrumbsComponent -> addShortcut -> ", decodeURIComponent(b.caption));
    return b.caption;}).join('/')}: `, currentPath);
    let a = this.router.parseUrl(this.router.url);
    console.log('Route: ', a);
  }
}
